import * as API from '../api'

export const FETCH_AUTH = 'FETCH_AUTH'
export const FETCHING_AUTH = 'FETCHING_AUTH'
export const FETCH_AUTH_ERROR = 'FETCH_AUTH_ERROR'
export const CLEAR_ERROR = 'CLEAR_ERROR'
export const SET_ERROR = 'SET_ERROR'
export const SET_SUCCESS_MESSAGE = 'SET_SUCCESS_MESSAGE'
export const SET_FAILURE_MESSAGE = 'SET_FAILURE_MESSAGE'
export const STOP_FETCHING = 'STOP_FETCHING'
export const FETCH_HEADERS = 'FETCH_HEADERS'

export const fetchAuthentication = user => {
  return dispatch => {
    dispatch({ type: FETCHING_AUTH })
    dispatch({
      type: CLEAR_ERROR
    })

    return API.login
      .authenticate(user)
      .then(response => {
        const { headers, data = {} } = response
        dispatch({
          type: FETCH_HEADERS,
          tokenType: headers['token-type'],
          accessToken: headers['access-token'],
          client: headers['client'],
          expiry: headers['expiry'],
          uid: headers['uid']
        })

        dispatch({
          type: FETCH_AUTH,
          userName: data.name,
          userId: data.user_id,
          areaId: data.area_id,
          areaName: data.area_code ? `${data.area_code} - ${data.area_name}` : data.area_name,
          areaCode: data.area_code,
          areaResponsible: data.area_responsible,
          businessUnitResponsible: data.business_unit_responsible,
          canChangeArea: data.can_change_area,
          permissions: data.permissions
        })
      }).catch(error => {
        dispatch({ type: FETCH_AUTH_ERROR })
        dispatch({
          type: SET_ERROR,
          error
        })
        return Promise.reject(error)
      })
  }
}

export const fetchRecoverPassword = user => {
  return dispatch => {
    dispatch({ type: FETCHING_AUTH })
    dispatch({
      type: CLEAR_ERROR
    })

    return API.login
      .recoverPassword(user)
      .then(response => {
        dispatch({ type: STOP_FETCHING })
        dispatch({ type: SET_SUCCESS_MESSAGE, message: ((response || {}).data || {}).message })
      }).catch(error => {
        dispatch({ type: FETCH_AUTH_ERROR })
        dispatch({
          type: SET_ERROR,
          error
        })
        return Promise.reject(error)
      })
  }
}

export const fetchRegisterPassword = form => {
  return dispatch => {
    dispatch({ type: FETCHING_AUTH })
    dispatch({
      type: CLEAR_ERROR
    })

    return API.login
      .registerNewPassword(form)
      .then(response => {
        dispatch({ type: STOP_FETCHING })
        dispatch({ type: SET_SUCCESS_MESSAGE, message: ((response || {}).data || {}).message })
      }).catch(error => {
        dispatch({ type: FETCH_AUTH_ERROR })
        dispatch({
          type: SET_ERROR,
          error
        })
        return Promise.reject(error)
      })
  }
}

export const clearErrors = () => {
  return dispatch => {
    dispatch({
      type: CLEAR_ERROR
    })
  }
}

export const setSuccessMessage = message => {
  return dispatch => {
    dispatch({ type: SET_SUCCESS_MESSAGE, message })
  }
}

export const setFailureMessage = message => {
  return dispatch => {
    dispatch({ type: SET_FAILURE_MESSAGE, message })
  }
}


// WEBPACK FOOTER //
// ./src/actions/login.js